import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save'; // Import the Save icon
import EditNoteIcon from '@mui/icons-material/EditNote';
import RefreshIcon from '@mui/icons-material/Refresh';


function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, userId, token, logout]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);


    const fetchtableData = async () => {
        setLoading(true);

        // Check if token exists
        if (!token) {
            logout();
            history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            return;
        }

        try {
            const response = await fetchData('CategoryApi', `/${companyId}`, token);

            if (response.responseCode === '1111') {
                setData(response.response_data);
                setFilteredData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error.message || error);

            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        deleteData('CategoryApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('CategoryApi', `${itemId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [editItemId, setEditItemId] = useState(null);
    const [editedCategoryOrderNo, seteditedCategoryOrderNo] = useState(null);

    const handleEdit = (itemId, currentRouteSequenceNo) => {
        setEditItemId(itemId);
        seteditedCategoryOrderNo(currentRouteSequenceNo);
    };

    const handleCategoryNoChange = (event) => {
        seteditedCategoryOrderNo(event.target.value);
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const updatedData = {
            Id: editItemId,
            CategoryOrderNo: editedCategoryOrderNo,
            ModifiedBy: userId,
        };

        updateData('CategoryApi', `catogeryOrderNo/${editItemId}`, updatedData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                setIsLoading(false);
                // Reload the page after updating
                window.location.reload();

            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='uppercase productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Variant</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                {/* {hasCreateMasterPermission && ( */}
                <div className='w-1/4 mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search by variant name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>
                <Tooltip title="Create New Item">
                    <Link to="/itemCreate" className="inline-block">
                        <Button
                            style={{
                                background: 'linear-gradient(to right, darkslategray, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '35px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <AddIcon style={{ fontWeight: 'bolder' }} /> Create

                        </Button>
                    </Link>
                </Tooltip>
                {/* )} */}

            </div>



            <div className='w-full mb-2 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#0B5345' }}>

                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '3px' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '3px' }}>Order No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '3px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '3px' }}>Category</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', width: '950px', color: 'white', fontWeight: 'bolder', padding: '3px' }}>Item Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '3px' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: 'white' }}>

                            {filteredData.map((item, index) => (
                                <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'}>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', textAlign: 'center', padding: '5px' }}>
                                        {editItemId === item.id ? (
                                            <input
                                                type="text"
                                                value={editedCategoryOrderNo}
                                                onChange={handleCategoryNoChange}
                                            />
                                        ) : (
                                            item.categoryOrderNo
                                        )}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '10px', fontWeight: 'bold', padding: '5px' }}>
                                        {editItemId === item.id ? (
                                            <>
                                                <Tooltip title="Save Category Order Number">
                                                    <IconButton onClick={(event) => handleSubmit(event, item.id)}>
                                                        <SaveIcon style={{ color: 'green', height: '19px' }} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Refresh">
                                                    <IconButton onClick={handleRefresh}>
                                                        <RefreshIcon style={{ color: 'blue', height: '19px' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        ) : (
                                            <Tooltip title="Edit Category Order Number">
                                                <IconButton onClick={() => handleEdit(item.id, item.categoryOrderNo)}>
                                                    <EditNoteIcon style={{ color: 'darkgoldenrod' }} disabled={isLoading} />
                                                    {isLoading && <CircularProgress size={24} />}
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black' }}>{item.categoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black' }}>{item.name}</TableCell>
                                    <TableCell sx={{
                                        borderBottom: '1px solid #FFE1E2', padding: '5px', color: 'black', width: '20 % '
                                    }}>
                                        < Link to={`/itemDetail/${item.id}`
                                        } >
                                            <IconButton>
                                                <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold', cursor: "pointer" }} />
                                            </IconButton>
                                        </Link>
                                        {hasEditMasterPermission && (
                                            <Link to={`/itemEdit/${item.id}`}>
                                                <IconButton>
                                                    <EditIcon style={{ color: 'blueviolet', cursor: "pointer" }} />
                                                </IconButton>
                                            </Link>
                                        )}
                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.isActive ? openConfirmDialog(item.id) : handleActivate(item.id))}>
                                                {item.isActive ? <DeleteIcon style={{ color: 'brown', cursor: "pointer" }} /> : <ActivateIcon />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div >
        </div >
    );
}

export default ItemIndex;

